var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnexar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1681 17L0 15.811L2.46135 13.3497H0.584049V11.681H5.29816V16.3951H3.62945V14.5386L1.1681 17ZM6.96687 16.6871V15.0184H11.973V5.84049H7.80123V1.66871H1.96074V10.0123H0.292025V1.66871C0.292025 1.20982 0.455419 0.816973 0.782209 0.490184C1.109 0.163395 1.50184 0 1.96074 0H8.63558L13.6417 5.00613V15.0184C13.6417 15.4773 13.4783 15.8701 13.1515 16.1969C12.8247 16.5237 12.4319 16.6871 11.973 16.6871H6.96687Z",
    fill: "#6B671A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnexar);
export default __webpack_public_path__ + "static/media/anexar.11152e7ebec4a73523c80179fd67df8b.svg";
export { ForwardRef as ReactComponent };